import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { ApiBaseResponse } from '../models';
import { Observable } from 'rxjs';
import { AuctionAnnouncement } from '../models/auctionAnnouncement';

@Injectable({
  providedIn: 'root'
})
export class AuctionAnnouncementService {
  private apiUrl: string = environment.apiUrl;

  constructor(private http: HttpClient) { }

  getAuctionAnnouncementById(auctionId: number): Observable<AuctionAnnouncement> {
    let param = new HttpParams();
    param = param.append('auctionId', '' + auctionId);
    return this.http.get<ApiBaseResponse<AuctionAnnouncement>>(`${this.apiUrl}/auctionAnnouncement`, { params: param })
      .pipe(map((it) => (it.data)));
  }

  // this is for public
  getAuctionAnnouncementByCode(auctionCode: string): Observable<AuctionAnnouncement> {
    let param = new HttpParams();
    param = param.append('auctionCode', auctionCode);
    return this.http.get<ApiBaseResponse<AuctionAnnouncement>>(`${this.apiUrl}/auctionAnnouncement`, {
      params: param
    }).pipe(map((it) => (it.data)));
  }

  addEditRemoveAuctionAnnouncement(auctionId: number, announcement: string, isRemoveAnnouncement: boolean = false): Observable<AuctionAnnouncement> {
    let request: Observable<ApiBaseResponse<AuctionAnnouncement>>;
    if (isRemoveAnnouncement) {
      request = this.http.patch<any>(`${this.apiUrl}/auctionAnnouncement`, {
        auctionId: auctionId
      })
    } else {
      request = this.http.post<any>(`${this.apiUrl}/auctionAnnouncement`, {
        auctionId: auctionId,
        text: announcement
      })
    }
    return request.pipe(map((it) => (it.data)));
  }

}
